/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_IntroInputs */

const en_projects_intro = /** @type {(inputs: Projects_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software we have delivered and experiences we are exploring. A closer look at the decisions behind the work.`)
};

const lv_projects_intro = /** @type {(inputs: Projects_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programmatūra, ko esam izveidojuši, un lietošanas pieredzes, ko pētām. Iepazīstiet lēmumus, kas veido katru darbu.`)
};

/**
* | output |
* | --- |
* | "Software we have delivered and experiences we are exploring. A closer look at the decisions behind the work." |
*
* @param {Projects_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const projects_intro = /** @type {((inputs?: Projects_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_projects_intro(inputs)
	return en_projects_intro(inputs)
});